<template>
    <div class="wating_mask" :class="{ show: showWaiting }">
        <div class="tips_box">{{ $t('msg.waiting') }}</div>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'waitingMask',
    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        },
        showWaiting() {
            return this.$store.state.waiting;
        }
    },
    methods: {
        ...mapMutations(['SET_STATE', 'SHOW_POPUP', 'SET_LANG']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        }
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
.wating_mask {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    display: none;

    &.show {
        display: block;
    }

    .tips_box {
        width: 271px;
        height: 174px;
        background: url('~@/assets/img/bg_waiting.png') center no-repeat;
        background-size: cover;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -174/2px 0 0 -270/2px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        color: #000;
    }
}
</style>
